import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import CampaignWizard from '../../campaign-wizard/CampaignWizard';
import { useEyeconxStore } from '../../../store/eyeconxStore';

function CreateEmailNewsletter() {
    const navigate = useNavigate();
    const clinicId = useEyeconxStore((state) => state.user?.clinicId);

    const steps = [
        { id: 1, title: 'Select Template', subtitle: 'Choose a template or start blank', component: 'TemplateSelection' },
        { id: 2, title: 'Newsletter Information', subtitle: 'Basic information', component: 'CampaignInformation' },
        { id: 3, title: 'Subject Line', subtitle: 'Subject line for email', component: 'SubjectLine' },
        { id: 4, title: 'Content', subtitle: 'Main content of the email', component: 'EmailContent' },
        { id: 5, title: 'Patient List', subtitle: 'Select patients that will receive email', component: 'PatientList' },
        { id: 6, title: 'Complete', subtitle: 'Process the Newsletter', component: 'Complete' },
    ];

    const handleSubmit = async (formData) => {
        const name = formData.campaignName?.trim();
        const title = formData.subjectLine?.trim();
        const htmlContent = formData.htmlContent?.trim();
        const patientIds = (formData.selectedPatients || [])
            .map((patient) => patient.id)
            .filter(Boolean);

        if (!clinicId) {
            toast.error('Clinic is not available. Please sign in again.');
            return;
        }
        if (!name) {
            toast.error('Newsletter name is required.');
            return;
        }
        if (!title) {
            toast.error('Email subject is required.');
            return;
        }
        if (!htmlContent) {
            toast.error('Email content is required.');
            return;
        }
        if (patientIds.length === 0) {
            toast.error('Select at least one patient before launching.');
            return;
        }

        // Launch API will be wired in a follow-up; keep validation + UX ready.
        toast.info(
            `Email newsletter ready for ${patientIds.length} recipient${
                patientIds.length === 1 ? '' : 's'
            }. Launch API not connected yet.`
        );
        navigate('/newsletter/email');
    };

    return (
        <CampaignWizard
            title="Create Email Newsletter"
            description="Send regular updates and news to your patients via email."
            icon="bi-envelope-paper"
            navigatePath="/newsletter/email"
            campaignType="email"
            entityLabel="Newsletter"
            patientCampaignType="newsletter"
            steps={steps}
            onSubmit={handleSubmit}
        />
    );
}

export default CreateEmailNewsletter;
